export default __webpack_public_path__ + "static/media/home_image.0b2f3372.png";